import { render } from "./index.vue?vue&type=template&id=729b324a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=729b324a&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-729b324a"

export default script